exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.merge-summary[data-v-44e4b0b6] {\n  margin: 20px 0;\n}\n.merge-schools-processing[data-v-44e4b0b6],\n.merge-schools-success[data-v-44e4b0b6],\n.merge-schools-error[data-v-44e4b0b6] {\n  padding: 20px 0;\n}\n", ""]);

// exports
